import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

export default function SectionCard({
  title,
  description,
  eyebrow,
  actions,
  accentColor,
  children,
  sx,
  contentSx,
  ...paperProps
}) {
  return (
    <Paper
      variant="outlined"
      sx={(theme) => ({
        p: { xs: 3, md: 4 },
        borderRadius: theme.radius.base,
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        ...(accentColor ? { borderLeft: `4px solid ${theme.palette[accentColor]?.main || accentColor}` } : {}),
        ...sx,
      })}
      {...paperProps}
    >
      {(eyebrow || title || description || actions) ? (
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', md: 'flex-start' }}
          sx={{ mb: children ? 3 : 0 }}
        >
          <Box sx={{ minWidth: 0, maxWidth: 900 }}>
            {eyebrow ? (
              <Typography variant="overline" color="text.secondary">
                {eyebrow}
              </Typography>
            ) : null}
            {title ? (
              <Typography variant="h4" component="h1" fontWeight={800} sx={{ mt: eyebrow ? 0.75 : 0 }}>
                {title}
              </Typography>
            ) : null}
            {description ? (
              <Typography color="text.secondary" sx={{ mt: 1.5 }}>
                {description}
              </Typography>
            ) : null}
          </Box>
          {actions ? <Box>{actions}</Box> : null}
        </Stack>
      ) : null}

      {children ? <Box sx={contentSx}>{children}</Box> : null}
    </Paper>
  );
}